// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BookingProvider } from './contexts/BookingContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import useRevealOnScroll from './hooks/useRevealOnScroll';
import './styles/App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import SetupSecretCodeModal from './components/Auth/SetupSecretCodeModal';
import Home from './pages/Home/Home';
import SalonList from './pages/SalonList/SalonList';
import MessagesPage from './pages/Messages/MessagesPage';
import SalonDetail from './pages/SalonDetail/SalonDetail';
import Booking from './pages/Booking/Booking';
import RecapPage from './pages/Booking/RecapPage';
import ConfirmationPage from './pages/Booking/ConfirmationPage';
import MyReservations from './pages/Client/MyReservations';
import ProfilePage from './pages/Client/ProfilePage';
import Favorites from './pages/Client/Favorites'; 
import LeaveReviewPage from './pages/Client/LeaveReviewPage';
import PaymentPage from './pages/Booking/PaymentPage';
import CguPage from './pages/Legal/CguPage';
import PrivacyPage from './pages/Legal/PrivacyPage';
import MentionsPage from './pages/Legal/MentionsPage';


function AppShell() {
  const revealRef = useRevealOnScroll();
  const { needsSecretCodeSetup } = useAuth();

  return (
    <div className="app" ref={revealRef}>
      {needsSecretCodeSetup && <SetupSecretCodeModal />}
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/salons" element={<SalonList />} />
          <Route path="/messages" element={<MessagesPage />} />
          <Route path="/salon/:id" element={<SalonDetail />} />
          <Route path="/booking/:salonId" element={<Booking />} />
          <Route path="/booking/new" element={<Booking />} />
          <Route path="/booking/recap" element={<RecapPage />} />
          <Route path="/booking/payment" element={<PaymentPage />} />
          <Route path="/booking/confirmation" element={<ConfirmationPage />} />
          <Route path="/reservations" element={<MyReservations />} />
          <Route path="/profil" element={<ProfilePage />} />
          <Route path="/favoris" element={<Favorites />} />
          <Route path="/review" element={<LeaveReviewPage />} />
          <Route path="/cgu" element={<CguPage />} />
          <Route path="/confidentialite" element={<PrivacyPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/mentions-legales" element={<MentionsPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BookingProvider>
        <Router>
          <AppShell />
        </Router>
      </BookingProvider>
    </AuthProvider>
  );
}

export default App;